export enum AppEvents {
  RouteChange = "routeChange",
}
